import { ISelectedLocalsRepositoryCB } from "../interfaces/ISelectedLocalsRepository";

const RemoveSelectedLocalsUseCase = (_dashboardRepository: ISelectedLocalsRepositoryCB): void => {
    const dashboardRepository = _dashboardRepository();
    dashboardRepository.remove();
}

export default RemoveSelectedLocalsUseCase;